module.exports = __webpack_public_path__ + "23e3441b190fa0397c531f5908e03097.MP3";